var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#CB3050"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 29.5,
    height: 29.5,
    rx: 4.75,
    stroke: "#545565",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4343 21.5897L7.2343 16.0647C6.9219 15.7328 6.9219 15.1946 7.2343 14.8627L8.36565 13.6606C8.67805 13.3286 9.18462 13.3286 9.49702 13.6606L13 17.3824L20.503 9.41057C20.8154 9.07864 21.3219 9.07864 21.6343 9.41057L22.7657 10.6127C23.0781 10.9446 23.0781 11.4828 22.7657 11.8147L13.5657 21.5898C13.2532 21.9217 12.7467 21.9217 12.4343 21.5897Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck2);
export default __webpack_public_path__ + "static/media/check2.53d2bb7de233ca3ef7e6463e28e3d4aa.svg";
export { ForwardRef as ReactComponent };